// extracted by mini-css-extract-plugin
module.exports = {"colorPopup":"#363738","colorBackground05":"rgba(42,45,44,0.5)","content":"BoostTile_content__X3ZW3","loadingText":"BoostTile_loadingText__2Ln8R"};